import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { UserProvider } from '@auth0/nextjs-auth0/client';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import Script from 'next/script';
import { Brand } from '../../lib/brand';
import { queryClient } from '../../lib/init';
import { RootStoreProps } from '../../stores/RootStore';
import { RootStoreProvider } from '../../stores/RootStoreProvider';
import { GrowthBookProvider } from './GrowthBookProvider';
import NotificationProvider from './NotificationProvider';

interface AppProviderProps {
    store?: RootStoreProps;
    brand: Brand;
}

const AppProviders: React.FC<React.PropsWithChildren<AppProviderProps>> = ({ children, brand, store }) => (
    <>
        <Script src="https://widget.cloudinary.com/v2.0/global/all.js" type="text/javascript" />
        <GrowthBookProvider>
            <UserProvider user={store?.authStore?.user}>
                <RootStoreProvider store={store} brand={brand}>
                    <NotificationProvider>
                        <QueryClientProvider client={queryClient}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>{children}</LocalizationProvider>
                        </QueryClientProvider>
                    </NotificationProvider>
                </RootStoreProvider>
            </UserProvider>
        </GrowthBookProvider>
    </>
);
export default AppProviders;
